import React from 'react';
import "./index.css";

function SwitchButton (props) {

	const {active, onClick, inputRef} = props;

	return (
		<div onClick={onClick} className="switch-button mx-3" ref={ inputRef }>
			{
				active
					?
					<div className={`bg active`}>
						<div className="cursor"/>
					</div>
					:
					<div className={`bg`}>
						<div className="cursor"/>
					</div>
			}
		</div>
	)
}

export default SwitchButton;
